import classNames from 'classnames';

import { trans } from '@spotahome/soyuz/client';

import KeyWithKeyRing from '../icons/KeyWithKeyRing';

import styles from './CreateAnAccount.module.scss';

const CreateAnAccount = ({ className = '' }) => {
  const classes = classNames(styles['create-an-account'], className);
  return (
    <div className={classes}>
      <div className={styles['create-an-account__text']}>
        <h5 className={styles['create-an-account__title']}>
          {trans('create.account.title')}
        </h5>
        <p className={styles['create-an-account__description']}>
          {trans('create.account.description')}
        </p>
      </div>
      <KeyWithKeyRing className={styles['create-an-account__icon']} />
    </div>
  );
};

export default CreateAnAccount;
